var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlerpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 174",
    style: {
      enableBackground: "new 0 0 142 174"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F1D30;}\n\t.st1{fill:#D092DD;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,42.3c-7.5,0-23,0-25.6,0l-1.4,0l0,3c0.1,14.4,3.1,26.2,12,36.5c10.4,11.9,25.4,15.4,38.7,22.5 c4.7,2.5,10.1,5.8,10.1,11.9c0,7.8-6,12.6-18.1,12.6c-10.8,0-22.7-5.6-32.1-13.5l-16.7,20.1c13.1,12.4,31.1,18.7,48,18.7 c31.1,0,49-18.7,49-40.2c0-5.2-0.8-10.5-2.9-15.3c-2.8-6.5-7.7-11.6-13.6-15.3c-0.1-0.1-0.3-0.2-0.4-0.3c-6.4-4.1-13.2-6.4-20.2-9 c-1.6-0.6-3.1-1.2-4.7-1.8C64.8,68,55.8,61.8,53.6,50.2c0-0.2-0.4-3.1-0.4-5V42.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.8,37.6c0,12.6,10.2,22.8,22.8,22.8c12.6,0,22.8-10.2,22.8-22.8c0-12.6-10.2-22.8-22.8-22.8 C79,14.8,68.8,25,68.8,37.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlerpLogo);
export default __webpack_public_path__ + "static/media/slerp-logo.e6d5fe7bc6f24238b4a39a64e61c0e42.svg";
export { ForwardRef as ReactComponent };